import script from "./AnalyzeComparisonChoiceActivity.vue?vue&type=script&lang=ts&setup=true"
export * from "./AnalyzeComparisonChoiceActivity.vue?vue&type=script&lang=ts&setup=true"

import "./AnalyzeComparisonChoiceActivity.vue?vue&type=style&index=0&id=128ec272&lang=scss"

const __exports__ = script;

export default __exports__